module.exports = __webpack_public_path__ + "static/media/yesterdayImageMobile.4d929b79.png";